export * from './label.styled';
